module.exports = __webpack_public_path__ + "img/speaker.16217d48.svg";